module.exports = __webpack_public_path__ + "static/img/checked.a2da2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checked.png
// module id = e/Aq
// module chunks = 0